module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_ibaraki-72c55970f671ebdae3ffe7bda7fd404e.png";